import { company } from 'kts-platform-frame/api';
enum Urls {

    /************************************** 用户基础操作接口 start**********************************/
    /**
     * 用户登录
     * @see http://172.21.16.118:8004/swagger-ui.html#!/web-auth-biz-controller/webLoginUsingPOST
     */
    WEB_TOKEN_LOGIN = '/auth/web/login',

    /** 用户的所有公司列表 */
    COMPANY_LIST = '/global/account/company/list',

    /** 获取用户数据 */
    COMPANY_USER_INFO = '/zone/company/user/info',

    /** 登录公司 */
    AUTH_CWEB_LOGIN = '/auth/web/company-switch',

    /** 获取公司已安装应用列表 */
    APP_INSTANCE_QUERY = '/zone/open/app-instance/query',

    /************************************** 用户基础操作接口 end**********************************/

    /** 发票组的发票组列表 */
    ZONE_GROUPLIST = '/zone/grouplist',

    /** 查询发票组合发票租明细 */
    ZONE_GROUP_INFO = '/zone/invoice/biz-group/group-info',

    /** 保存发票组明细 */
    ZONE_SAVE_DETAIL = '/zone/invoice/biz-group/save-detail',

    /** 发票组的所有发票列表 */
    ZONE_INVOICELIST = '/zone/invoicelist',

    // POST /zone/invoice/biz-logging/single/{loggingType}
    // MANUAL (1, "手工录入"),
    // SCANNER_GUN (2, "扫描枪录入"),
    // 发票录入-四要素
    /** 录入放票信息(手工录入) */
    logInvoiceMANUAL = '/zone/invoice/biz-logging/single/MANUAL',

    /** 录入放票信息（扫描器抢） */
    logInvoiceSCANNER_GUN = '/zone/invoice/biz-logging/single/SCANNER_GUN',

    /** 发票列表查询 */
    //POST /zone/invoice/biz-logging/query-list
    //发票列表查询
    group_invoice_list = '/zone/invoice/biz-logging/query-list',

    //POST /zone/invoice/biz-logging/update-receive
    //批量更新业务状态
    group_update_finance = '/zone/invoice/biz-logging/update-receive',

    //POST /zone/invoice/biz-logging/group-receive
    //按发票组更新业务状态
    GROUP_RECEIVE = '/zone/invoice/biz-logging/group-receive',

    //GET /zone/invoice/notional-pooling/auto
    //发票归集-自动归集公司所有的发票
    NOTIONAL_POOLING = '/zone/invoice/notional-pooling/auto',

    //POST /zone/invoice/biz-logging/query-log
    //发票录入日志列表查询
    group_query_log = '/zone/invoice/biz-logging/query-log',

    /** 查询发票组概要信息列表 */
    group_resume = '/zone/invoice/biz-group/group-resume',

    // POST /zone/invoice/biz-group/submitGroup
    // 发票提交
    group_submitGroup = '/zone/invoice/biz-group/submitGroup',

    /** 移动发票到指定发票组 */
    GROUP_MOVE = '/zone/invoice/biz-group/group-move',

    /** 删除发票组 */
    GROUP_DELETE = '/zone/invoice/biz-group/group-delete',

    // POST /zone/invoice/biz-group/create-simplegroup
    // 创建简单发票组-自动生成名称 弃用
    CREATE_GROUP = '/zone/invoice/biz-group/create-simplegroup',

    /** 发票影像文件查询 */
    //POST /zone/invoice/biz-image/query
    //发票影像文件查询
    BIZ_IMAGE_QUERY = '/zone/invoice/biz-image/query',

    /** 发票录入-获取影像文件录入的token */
    group_getUploadToken = '/zone/invoice/biz-logging/img-token',

    /** getInvoiceDetails 获取发票详情 */
    getInvoiceDetails = '/zone/invoice/biz-logging/get-detail',

    //     GET /zone/invoice/biz-realcheck/again/date/{loggedDate}
    // 重新验真某天失败的,且可以重新查验的发票 yyyy-MM-dd
    realcheckAgain = '/zone/invoice/biz-realcheck/again/date/',

    /** excel上传后错误文件下载地址 */
    DOWNLOADFILE = '/zone/invoice/biz-logging/downloadFile',

    /** POST /zone/invoice/biz-realcheck/again/{entryId}重新验真 */
    REALCHECK = '/zone/invoice/biz-realcheck/again/',

    /** 下载Excel模板 */
    group_downloadTemplate = '/zone/invoice/biz-logging/downloadTemplate',

    /** 发票录入-Excel */
    group_uploadFile = '/zone/invoice/biz-logging/upload-file',

    /** 发票录入-获取扫描仪录入的token */
    group_ocrtoken = '/zone/invoice/biz-logging/ocr-token',

    /** 第三方ocr_token */
    third_ocr_token = '/global/invoice/third-realcheck/ocr-token',

    /** 发票组ocr */
    caf_ocr_token = '/zone/caf/invoice-logging/ocr-token',

    /** 发票ocr */
    createLoggingOcrToken = '/invoice/income/logging/createLoggingOcrToken',

    // GET /zone/invoice/biz-group/create-sequence
    // 生成发票组编号
    group_create_sequence = '/zone/invoice/biz-group/create-sequence',

    /** 根据公司信息查询发票列表 */
    GROUP_GET_GROUP_LIST = '/zone/invoice/biz-group/group-list',

    // POST /zone/invoice/biz-group/group-list
    // 根据公司信息查询发票列表
    group_group_list = '/zone/invoice/biz-group/group-list',

    //     GET /zone/invoice-manage/setting/isAllGroupSubmit-front
    // isAllGroupSubmit  查询是否整组提交
    group_isAllGroupSubmit = '/zone/invoice-manage/setting/isAllGroupSubmit-front',

    //     POST /zone/invoice/biz-logging/submit-many
    // 发票组和零星发票提交 整组发票提交
    group_submit_many = '/zone/invoice/biz-logging/submit-many',

    // POST /zone/invoice/biz-logging/submit
    // 发票提交 非整组提交
    group_biz_logging_submit = '/zone/invoice/biz-logging/submit',

    /************************************** 进项结算单相关api start**********************************/
    //进项结算单列表
    INPUT_SETTLEMENT_LIST = '/notice/income',
    // 进项结算单详情
    INPUT_SETTLEMENT_DETAIL = '/notice/income',
    // 进项结算单匹配详情
    INPUT_SETTLEMENT_VIEW_MATCH = '/notice/matchIncome',
    // 进项结算单匹配
    INPUT_SETTLEMENT_MATCH = '/notice/income/listInvoicesByCondition',
    // 进项结算单匹配保存
    INPUT_SETTLEMENT_SAVE_MATCH = '/notice/matchIncome',
    // 进项结算单匹配完成
    INPUT_SETTLEMENT_FINISH_MATCH = '/notice/income/batchFinish',
    //进项结算单发送
    INPUT_SETTLEMENT_SEND = '/notice/income/batchSend',
    //进项结算单作废
    INPUT_SETTLEMENT_INVALID = '/notice/income/batchInvalid',

    // 发票根据参数查询
    INVOICE_QUERY = '/notice/income/listInvoices',

    // GET POST /zone/invoice-manage/manage/query
    // query 进项发票管理列表
    BIZQUERY = '/zone/invoice-manage/manage/query',

    // POST /zone/invoice-manage/image/img-query
    //发票影像文件查询
    // 发票管理-获取发票的影像地址
    getImage = '/zone/invoice-manage/image/img-query',

    //GET GET /zone/invoice-manage/image/relationToken
    //发票管理-获取关联发票影像文件的token
    GETSINGLEUPLOADTOKEN = '/zone/invoice-manage/image/relationToken',

    // GET /zone/invoice-manage/manage/update-financeState
    // updateFinanceState 修改发票业务状态
    changeFinanceState = '/zone/invoice-manage/manage/update-financeState',

    //POST /zone/invoice-manage/detail/get-detail
    //查询发票详情和验真时间
    getInvoiceByBizId = '/zone/invoice-manage/detail/get-detail',

    //POST /zone/invoice/biz-logging/invoice-fetch
    //通过两要素拉取四要素
    invoice_fetch = '/zone/invoice/biz-logging/invoice-fetch',

    // GET /zone/invoice/biz-logging/save-log
    // 发票录入日志保存
    logging_save_log = '/zone/invoice/biz-logging/save-log',

    // GET /zone/invoice/biz-logging/get-log/{entryLogId}
    // 查询指定录入日志记录
    logging_get_log = '/zone/invoice/biz-logging/get-log',

    // POST /zone/invoice/biz-group/group-exist
    // 判断公司输入的发票组编号是否存在
    group_exist = '/zone/invoice/biz-group/group-exist',

    // GET /zone/invoice-manage/setting/isAutoSubmit-front
    // isAutoSubmit
    group_isAutoSubmit_front = '/zone/invoice-manage/setting/isAutoSubmit-front',

    /************************************** 进项结算单相关api end**********************************/




    /************************************** 勾选认证相关 api start**********************************/
    // 勾选列表
    INVOICE_AUTH_SELECT_LIST = '/invoiceauth',

    // 确认列表
    INVOICE_AUTH_CONFIRM_LIST = '/invoiceauth/queryInvoiceDraftPage',

    // 勾选发票
    INVOICE_AUTH_DRAFT = '/invoiceauth/updateInvoiceDraft',

    // 取消勾选发票
    INVOICE_AUTH_UNDRAFT = '/invoiceauth/cancelInvoiceDraft',


    //查询已勾选数据
    INVOICE_AUTH_QUERY_DRAFTED = '/invoiceauth/queryInvoiceDraftPage',

    //统计勾选
    INVOICE_AUTH_DRAFT_COUNT = '/invoiceauth/getInvoiceCountByCondition',

    // 勾选数据提交
    INVOICE_AUTH_COMMIT = '/invoiceauth/authInvoiceCommit',

    //扫描勾选
    INVOICE_AUTH_QRCODE = '/invoiceauth/qrcode',

    //文件上传勾选
    INVOICE_AUTH_DRAFT_BY_FILE = '/invoiceauth/updateInvoiceDraftByFile',

    //更新文件？
    INVOICE_AUTH_UPDATE = '/invoiceauth/updateInvoiceDraft',

    //下载Excel
    INVOICE_AUTH_DOWNLOAD_FILE = '/invoiceauth/downloadInvoiceDraftByFile/',

    // GET /invoiceauth/getInvoiceAuthBatchByPage
    // 发票管理-查询提交历史
    getInvoiceAuthBatchByPage = '/invoiceauth/getInvoiceAuthBatchByPage',

    //录入记录
    invoice_auth_log = '/invoiceauth/deduction/input/list',

    // GET /invoiceauth/getInvoiceAuthLogCountByCondition
    // 认证--提交批次统计查询
    getInvoiceAuthLogCountByCondition = '/invoiceauth/getInvoiceAuthLogCountByCondition',

    // GET /invoiceauth/getInvoiceAuthLogByPage
    // 发票管理-查询提交历史详情
    getInvoiceAuthLogByPage = '/invoiceauth/getInvoiceAuthLogByPage',

    // POST /invoiceauth/deduction/input/createOcrToken
    // 生成扫描仪录入Token
    deduction_createOcrToken = '/invoiceauth/deduction/input/createOcrToken',

    //     POST /invoiceauth/deduction/input/excel
    // 抵扣联录入-Excel
    deduction_excel = '/zuul/invoiceauth/deduction/input/excel',

    //     POST /invoiceauth/deduction/input/manualOrScanner
    // 抵扣联手工或扫描枪录入
    deduction_manualOrScanner = '/invoiceauth/deduction/input/manualOrScanner',

    //     POST /invoiceauth/deduction/ocr/callback
    // 抵扣联录入ocr回调
    deduction_callback = '/invoiceauth/deduction/ocr/callback',

    //     GET /invoiceauth/deduction/downloadTemplate
    // 下载抵扣联录入excel模板
    deduction_downloadTemplate = '/invoiceauth/deduction/downloadTemplate',

    //     POST /invoiceauth/deduction/input/query/image
    // 抵扣联录入记录详情
    deduction_image = '/invoiceauth/deduction/input/query/image',

    //     POST /invoiceauth/deduction/input/detail
    // 抵扣联录入记录详情
    deduction_detail = '/invoiceauth/deduction/input/detail',

    //     post /invoiceauth/deduction/input/supplement
    // 抵扣联补录
    deduction_supplement = '/invoiceauth/deduction/input/supplement',

    //     POST /invoiceauth/draftAllAfterFilter
    // 发票认证-全选
    draftAllAfterFilter = '/invoiceauth/draftAllAfterFilter',

    //     POST /invoiceauth/cancelDraftAllAfterFilter
    // 发票认证-全部取消勾选
    cancelDraftAllAfterFilter = '/invoiceauth/cancelDraftAllAfterFilter',

    //     POST /invoiceauth/deduction/input/downloadList
    // 抵扣联录入记录列表
    downloadList = '/invoiceauth/deduction/input/downloadList',



    /************************************** 勾选认证相关 api end **********************************/

    //下载比对结果
    INVOICE_AUTH_DOWNLOAD_COMPARE = '/invoicecompare/downloadInvoiceCompareResult',

    /************************************** 发票对比相关 api start **********************************/
    // 发票比对勾选列表
    INVOICE_AUTH_COMPARE_LIST = '/invoicecompare/queryInvoiceCompareByPage?',

    // 发票比对查询详情
    INVOICE_AUTH_COMPARE_DETAIL = '/invoicecompare/queryInvoiceCompareDetail',

    //增加发票对比批次
    INVOICE_AUTH_ADD_COMPARE = '/invoicecompare/addInvoiceCompare',

    // 删除发票对比批次
    INVOICE_AUTH_DEL_COMPARE = '/invoicecompare/delInvoiceCompare',

    // 删除某条对比明细
    INVOICE_AUTH_DEL_COMPARE_DETAIL = '/invoicecompare/delInvoiceCompareDetail',

    // 发票比对 上传excel
    INVOICE_AUTH_ADD_COMPARE_BY_FILE = '/invoicecompare/addInvoiceCompareByExcel',

    //发票比对 OCR 录入
    INVOICE_AUTH_ADD_COMPARE_BY_OCR = '/invoicecompare/createCompareOcrToken',

    // 发票比对 四要素录入
    INVOICE_AUTH_ADD_COMPARE_BY_FOURKEY = '/invoicecompare/fourElementsCompare',

    //下载发票批次详情
    INVOICE_AUTH_COMPARE_DETAIL_DOWNLOAD = '/invoicecompare/downloadInvoiceCompareResult/',

    // 下载发票对比文件模板
    INVOICE_AUTH_COMPARE_TEMPLATE_DOWNLOAD = '/invoicecompare/downloadTemplate',

    // 提交比对
    INVOICE_AUTH_COMPARE_COMMIT = '/invoicecompare/draftInvoiceByCompare',

    // 查询比对
    INVOICE_AUTH_COMPARE_DETAIL_QUERY = '/invoicecompare/queryInvoiceCompareByPage',

    // 查询ocr 文件地址
    INVOICE_AUTH_COMPARE_IMG_QUERY = '/invoicecompare/queryInvoiceCompareDetail/image',
    //获取当前税期
    taxPeriod_current = '/invoiceauth/taxPeriod/current',
    //刷新税期时间
    taxPeriod_refresh = '/invoiceauth/taxPeriod/refresh',
    //查看发票详情
    invoice_auth_getDetail = '/invoiceauth/getDetail',

    //     POST /invoiceauth/taxPeriod/change
    // changeTaxPeriod
    changeTaxPeriod = '/invoiceauth/taxPeriod/change',

    /************************************** 勾选认证相关 api end **********************************/


    /************************************** 部门接口地址 start**********************************/

    /************************************** 部门接口地址 start**********************************/

    /** 查询部门 */
    DEPARTMENT_LIST = '/zone/company/department/query',

    /**
     * 根据部门查询员工
     */
    FIND_DEPARTMENT_USER = '/zone/company/department/user-list',


    /** 新增部门 */
    CREATE_DEPARTMENT = '/zone/company/department/create',

    /** 删除部门 */
    DELETE_DEPARTMENT = '/zone/company/department/deleted',

    /** 修改部门 */
    UPDATE_DEPARTMENT = '/zone/company/department/update',

    /** 部门添加人员 */
    USER_CREATE = '/zone/company/department/user-create',

    /** 修改上级部门 */
    PARENT_UPDATE = '/zone/company/department/parent-update',

    DEPARTMENT_INFO = '/zone/company/department/info',

    DEPARTMENT_PARENT_AVAILABLE = '/zone/company/department/parent-available',

    /************************************** 部门接口地址 end**********************************/

    /************************************** 关联公司及集团资料接口地址 start**********************************/

    /** 获取关联公司数据 */
    ZONE_CONNECTIONLIST = '/zone/company/connection/list',

    /** 禁用关联公司状态 */
    ZONE_CONNECTDISABLE = '/zone/company/connection/disable',

    /** 集团公司资料 */
    ZONE_ORGINFO = '/zone/company/org/info',

    /** 集团公司禁用 */
    ZONE_ORGUPDATE = '/zone/company/org/update',

    /** 添加公司 */
    ZONE_ORGCREATE = '/zone/mgmt/org/company/create',

    /** 集团公司启用 */
    ZONE_CONNECTENABLE = '/zone/company/connection/enable',
    /************************************** 关联公司及集团资料接口地址 end**********************************/

    /************************************** 登录页辅助接口地址 start**********************************/

    /** 邮箱重设密码，发送邮件 */
    LOGIN_FORGET_PWD = '/global/anon/reset/apply',

    /** 邮箱重设密码，验证 ticket */
    LOGIN_FORGET_CHECK = '/global/anon/reset/check',

    /** 邮箱重设密码，重置 */
    LOGIN_FORGET_DO = '/global/anon/reset/do',

    /** 邀请用户登录--邮箱验证 */
    LOGIN_ACTIVE_BIND_CHECK = '/global/anon/active-bind/check',

    /** 邀请用户设置密码? 忘记密码？ */
    LOGIN_ACTIVE_PWD = '/global/anon/active-bind/activate',
    /** 用户加入公司 */
    LOGIN_JOIN_COMPANY = '/global/anon/active-bind/bind',
    /** 验证密码 */
    passIsLegal = '/global/account/pass/is-legal',
    /** 修改手机号 */
    phoneUpdate = '/global/account/phone/update',
    /** 发送到手机验证 */
    validateCode = '/anno/zone/message-biz/validate-code/complex-post',
    
    /*************************新手引导 ************************/
    /************ 获取新手引导版本 *********/
    GET_CURRENT_ACCOUNT_INFO = '/global/account/current-info/get',
    /************ 修改新手引导版本 *********/
    UPDATE_GUIDE_VERSION = '/global/account/current-info/update',

    /************************************** 登录页辅助接口地址 end**********************************/

    /************************************** 用户中心接口地址 start**********************************/
    /*************************引导页  开始 ************************/
    GET_CURRENT_INFO_LIST = '/open-platform/app/info/guide',
    ACTIVATE_GUIDE_APP = '/open-platform/app/instance/guide-instance-activate',
    APPLY_ACTIVATE_APP = '/open-platform/app/info/apply/grant/apps',
    /*************************引导页  结束 ************************/
    /** 修改密码 */
    ACCOUNT_UPDATE_PWD = '/global/account/current-info/update-pass',

    /************************************** 登录页辅助接口地址 end**********************************/

    /******************************************** 用户管理相关url 开始*******************************************/

    /** 用户列表 */
    USER_LIST = '/zone/company/user/query',

    /** 禁用或激活用户 */
    USER_DISORENA = '/zone/company/user/disable',

    /** 用户详情 */
    USER_DETAIL = '/zone/company/user/info',

    /** 新增用户 */
    USER_ADD = '/zone/company/user/alone-create',

    /** 编辑用户 */
    USER_EDIT = '/zone/company/user/update',

    /** 重新邀请 */
    USER_SEND = '/zone/company/user/invite',

    /** 用户所在公司角色 */
    USER_COMPANY_ROLE = '/zone/role/company/query',

    /** 获取当前用户所在公司权限 */
    USER_CURRENT_ROLE = '/zone/userrole/info/query',

    /** 更新某个用户的角色 */
    USER_UPDATE_ROLE = '/zone/userrole/info/override',

    /** 获取用户的安全信息 */
    USER_SECURITY_MGR_get = '/zone/mgmt/user/security-mgr/get',

    /** 用户解锁 */
    USER_SECURITY_MGR_UNLOCK = '/zone/mgmt/user/security-mgr/unlock',

    /******************************************** 用户管理相关url 结束*******************************************/

    /******************************************** 角色公司相关url 开始*******************************************/

    /** 公司权限列表组 */
    SYSTEM_COMPANY_RULEGROUPS_LIST = '/zone/rulegroup/info/query-company',

    /** 角色的所有角色列表 */
    SYSTEM_ROLELIST = '/zone/role/company/query',

    /** 删除角色 */
    SYSTEM_ROLE_DELETE = '/zone/role/info/delete',

    /** 跟新角色 */
    SYSTEM_ROLE_UPDATE = '/zone/role/info/update',

    /** 新增角色 */
    SYSTEM_ROLE_CREATE = '/zone/role/info/create',

    /** 获取公司资料 */
    SYSTEM_COMPANYLIST = '/zone/company/info/get',
    /******************************************** 角色公司相关url 结束*******************************************/

    /** 查询发票附加信息（多张发票及发票组） */
    additionalList = '/zone/invoice/additional/list',

    /** 查询发票附加信息（单张发票）） */
    additionalListSingle = '/zone/invoice/additional/list-single',

    /** 根据选择的发票保存附加信息 */
    additionalSaveBatch = '/zone/invoice/additional/save-batch',

    /** 根据悬着的发票组保存的附加信息 */
    additionalSaveGroup = '/zone/invoice/additional/save-group',

    /******************************************** app应用 开始*******************************************/
    /** 第三方公司申请Code */
    getAppCode = '/api/integration/auth/code',
    /** 第三方公司获取Token信息 */
    getAppToken = '/open-platform/integration/auth/authorize-by-code',
    /** 第三方公司绑定授权 */
    bindAuthorize = '/open-platform/integration/auth/bind-authorize',
    /** 查询当前用户已授权的应用实例(弃用) */
    userQuery = '/open-platform/app/instance/user-query',
    /** 查询菜单可以显示的APP */
    queryMenuApp = '/open-platform/app/instance/query-menu',
    /** 查询我应用APP */
    queryMy = '/open-platform/app/instance/query-my',
    /** 查询APP的详情 */
    queryAppInfo = '/open-platform/app/instance/get',
    /** 查询应用分类 */
    appCategory = '/open-platform/app/category/query',
    /** app详情 */
    appInfoGet = '/open-platform/app/info/get',
    /** app应用市场搜索 */
    appInfoQuery = '/open-platform/app/info/query',
    /** app应用市场搜索不分页 */
    appInfoQueryNoPage = '/open-platform/app/info/query-no-page',
     /** app应用市场搜索不分页 */
     appMyQueryNoPage = '/open-platform/app/info/query-new',
    /** 查询当前公司已激活的应用实例 */
    companyQuery = '/open-platform/app/instance/company-query',
    /** 查询当前公司已激活的应用实例 */
    companyQueryNoPage = '/open-platform/app/instance/company-query-no-page',
    /** 禁用app */
    appInstanceDisable = '/open-platform/app/instance/disable',
    /** 激活应用 */
    appInstanceActivate = '/open-platform/app/instance/activate',
    /** 获取app权限信息 */
    getPermissions = '/open-platform/app/info/get-permissions',
    /** 修改app应用权限 */
    permissionOverride = '/open-platform/app/instance/permission-override',
    /** 获取应用实例权限 */
    permissionQuery = '/open-platform/app/instance/permission-query',
    /** 获取公司人员 */
    companyUserQuery = '/zone/company/user/query',
    /** 获取公司人员不分页查询 */
    companyUserQueryNoPage = '/zone/company/user/query-no-page',
    /** 刷新 */
    autoRefresh = '/open-platform/app/instance/auth-refresh',
    /******************************************** 公司注册相关url 开始*******************************************/

    /** 获取国家列表 */
    COUNTRY_LIST = '/global/location/country/info',

    /** 获取省列表 */
    STATE_LIST = '/global/location/country/states',

    /** 获取市区列表 */
    CITY_LIST = '/global/location/country/state-cities',

    /** 注册公司 */
    ACTIVE_COMPANY = '/global/anon/active-company/active',

    /** 检测公司 */
    CHECK_COMPANY = '/global/anon/active-company/check',

    /** 预检测公司名和税号 */
    PRE_CHECK_COMPANY = '/global/anon/company/info-check',

    /******************************************** 网络 start*******************************************/
    /**
     * 网络管理：平台网络列表
     */
    networkPlatformList = '/zone/network/connection/query-platform',
    /**
     * 网络管理：我的网络列表
     */
    networkMyList = '/zone/network/connection/query',
    /**
     * 网络管理： 发送链接请求
     */
    sendNetworkRequest = '/zone/network/connection/send-request',
    /** 网络管理，我的网络，接受链接 */
    acceptNetworkRelation = '/zone/network/connection/accept',
    /** 网络管理：我的网络，取消链接  */
    cancelNetworkRelation = '/zone/network/connection/cancel',
    /** 网络管理，我的网络，公司详情 */
    networkCompanyDetail = '/zone/network/connection/company-info',
    /** 网络管理，待加入公司的列表 */
    networkWaitingJoinList = '/zone/network/connection/query-waiting',
    /** 邀请公司,单个 */
    inviteOneNetworkCompany = '/zone/network/invitation/invite-single',
    /** 批量邀请公司，excel上传 */
    inviteBatchNetworkCompany = '/zone/network/invitation/invite-excel',
    /** 网络: 公司注册, 检验ticket是否已经有效 */
    checkTicketVisible = '/zone/network/registry/check',
    /** 公司注册，提交表单 */
    registryNetworkCompany = '/zone/network/registry/active',
    /** 公司注册，公司名字验证 */
    registry_info_check = '/zone/network/registry/info-check',

    /** 根据城市名称模糊查询城市 */
    fuzzyQueryCity = '/zone/company/location/query-cities',
    /** 添加公司备注 */
    updateCompanyRemark = '/zone/network/connection/update-remark',
    /** 我的网络，列表 */
    userNetworkMyList = '/zone/network/my-network',
    /** 我的网络，详情 */
    userNetworkCompanyDetail = '/zone/network/my-network/company-info',
    /** 我的网络，更新备注 */
    userUpdateCompanyRemark = '/zone/network/my-network/update-remark',
    /** 取消邀请 */
    networkCancelInvite = '/zone/network/invitation/invite-cancel',
    /** 打开发信息 */
    imInviteChat = '/zone/network/im/invite',

    /** 打开公共邀请链接 */
    inviteOpen = '/zone/network/invitation/invite-open',
    /** 检查check并根据ticket获取信息 */
    checkInvite = '/zone/network/anon/open-reg/check',
    /** 注册 */
    registerCompany = '/zone/network/anon/open-reg/reg',
    /** 检查参数是否合理 */
    checkParams = '/zone/network/anon/open-reg/param-check',


    /******************************************** 网络 end*********************************************/




    // POST /notice/output
    // list 销项列表 包括高级查询
    OUTLIST = '/notice/output',

    // POST /invoice/invoiceoutput
    // 发票管理-新增录入发票销项
    invoiceoutput = '/invoice/invoiceoutput',

    // GET /notice/matchOutput/{noticeId}/del
    // 销项通知单关联-删除关联
    delMatchOutput = '/notice/matchOutput',

    // GET /notice/matchOutput/{noticeId}
    // list
    matchOutput = '/notice/matchOutput/query-list',

    // POST /invoice/invoiceoutputs
    // 发票管理-根据发票ID查询发票销项
    invoiceoutputs = '/invoice/invoiceoutputs',

    // POST /notice/output/batchCancelInvoice
    // batchCancelInvoice 取消开票
    batchCancelInvoice = '/notice/output/batchCancelInvoice',

    // GET /notice/output/{noticeId}
    // getNoticeBillById 销项结算单详情
    getNoticeBillById = '/notice/output',

    // POST /notice/output/batchMakeInvoice
    // batchMakeInvoice 开票
    batchMakeInvoice = '/notice/output/batchMakeInvoice',

    // POST /notice/output/batchRefuse
    // batchRefuse 批量拒绝
    batchRefuse = '/notice/output/batchRefuse',

    // POST /notice/output/batchAccept
    // batchAccept 批量接受
    batchAccept = '/notice/output/batchAccept',

    /******************************************** 更新企业信息接口 *******************************************/

    // 更新银行信息
    bankUpdate = '/zone/company/info/bank-update',

    // 更新备注
    descUpdate = '/zone/company/info/desc-update',

    // 更新详情
    detailUpdate = '/zone/company/info/detail-update',

    // 更新图片
    imageUpdate = '/zone/company/info/image-update',
    /******************************************** 上传文件 *******************************************/

    // 上传文件
    uploadToken = '/zone/company/upload-token/get',

    // 公司风采
    // 上传图片
    elegantImagesUpload = '/zone/company/images/upload',
    // 设置主图
    elegantSetMainImage = '/zone/company/images/setMainImage',
    // 获取公司风采主图
    elegantGetMainImage = '/zone/company/images/getMainImage',
    // 获取风采图
    elegantImagesGet = '/zone/company/images/get',
    // 删除图片
    elegantImagesDelete = '/zone/company/images/delete',

    // 公司公开信息(不需登录)
    outsidInfo = '/zone/company/outside/info',
    // 公司公开信息发票列表
    detailPubConfig = '/sco-input-biz/email/company/config/detailPubConfig',
    // 公司公开信息,交付发票上传(不需登录)
    loggingUpload = '/zuul/sco-input-biz/ofd/input-log/logging/upload',
    //获取唯一标识
    getPublicUploadId = '/zuul/sco-input-biz/companyHomepage/getDeliverId',
    //文件上传
    publicUploadFile = '/zuul/sco-input-biz/companyHomepage/upload/file',
    //交付
    publicDelivery = '/zuul/sco-input-biz/companyHomepage/delivery',
    
    loggingCompanyDetail = '/sco-input-biz/email/company/config/detail-companyId',

    /******************************************** 单据 文档 *******************************************/
    // 获取单据列表
    documentQuery = '/document/v2/query',
    // 更改单据状态
    documentStatusUpdate = '/document/v2/status/update',
    // 更改发票状态
    invoiceStatusUpdate = '/document/v3/status/update',
    // 删除单据
    documentDelete = '/document/v2/delete',
    // 发送单据
    documentSend = '/document/v2/send',
    // 获取单据详情
    documentGet = '/document/v2/ui/get',
    // 获取单据详情(最新规则 用于编辑草稿)
    documentGetLatest = '/document/v2/ui/get-with-latest-rule',
    // 单据状态获取
    documentStatusGet = '/document/v2/status/get',
    // 新建单据 初始化化 单据
    documentDraftGet = '/document/v2/ui/draft/get',
    // 上传附件
    documentAttachmentCreate = '/zuul/document/v2/attachment/create',
    // 下载附件
    documentAttachmentGet = '/document/v2/attachment/get',
    // 计算单据 小计 合计
    documentCalculate = '/document/v2/calculate',
    // 创建
    documentCreate = '/document/v2/create',
    // 更新
    documentUpdate = '/document/v2/update',
    // 允许转换的单据 查看
    allowedDocType = '/document/v2/transform/allowed-doc-type',
    // 单据转换
    documentTransform = '/document/v2/transform',
    // 归档/取消归档
    documentArchive = '/document/v2/archive',
    // 文档相关信息
    documentInfoGet = '/document/v2/info/get',
    // 输入框验证
    checkField = '/document/v3/check-field',
    // 文档验证
    checkDocument = '/document/v3/check-document',
    // 根据documentUUid验证文档
    checkDocumentByUuid = '/document/v3/check-document-by-uuid',
    // 发票详情地址
    invoiceDetail = '/document/v3/get/details',
    /** 单据获取documentId */
    getDocumnetId = '/document/v3/info/get',

    /******************************************** 地址联动 *******************************************/

    countryInfo = '/zone/company/country/info',

    countryStateCities = '/zone/company/country/state-cities',

    countryStates = '/zone/company/country/states',

    /******************************************** 用户管理 *******************************************/

    user_manage_uery = '/zone/mgmt/user/query',

    user_manage_create = '/zone/mgmt/user/create',

    user_manage_preCheck = '/zone/mgmt/user/preCheck',

    user_manage_set_department = '/zone/mgmt/user/set-department',

    user_manage_export = '/zone/mgmt/user/template/export',

    user_info = '/zone/mgmt/user/info',

    user_manage_update = '/zone/mgmt/user/update',
    /** 创建用户：上传文件预检查接口 */
    userBatchPreTreated = '/zone/mgmt/user/batch-preTreated',
    /** 创建用户：上传文件接口 */
    userBatchCreate = '/zone/mgmt/user/batch-create',
    /** 公司内取消新增员工（管理员）邀请 */
    userInviteCancel = '/zone/mgmt/user/invite-cancel',

    /******************************************** 集团信息 *******************************************/

    /** 获取集团信息 */
    getOrgQINfo = '/zone/mgmt/org/get-by-company',
    /** 获取集团下公司 */
    getOrgCompany = '/zone/mgmt/org/company/list',
    /** 获取公司资料 */
    getCheckCompanyInfo = '/zone/mgmt//org/company/get',
    /** 公司名税号预检查 */
    preCheckCompanyInfo = '/zone/mgmt/org/company-info/preTreated',

    /******************************************** 公司资质 *******************************************/

    mgmt_qualification_create = '/zone/mgmt/qualification/create',

    mgmt_qualification_delete = '/zone/mgmt/qualification/delete',

    mgmt_qualification_info = '/zone/mgmt/qualification/info',

    mgmt_qualification_update = '/zone/mgmt/qualification/update',

    mgmt_qualification_list = '/zone/mgmt/qualification/list',

    mgmt_qualification_industry_list = '/zone/mgmt/qualification/industry-list',

    /******************************************** 消息中心接口 *******************************************/
    /** 获取用所有类型的未读消息数量 */
    MESSAGE_COUNT_UNREAD = '/zone/message-biz/general/count-unread',
    /******************************************** 消息中心接口 end *******************************************/

    /******************************************** 密码规则 *******************************************/
    pass_config_get_by_email = '/global/anon/pass-config/get-by-email',

    pass_config_get = '/global/account/pass-config/get',

    pass_change_by_email = '/global/anon/pass/change-by-email',
    /************************************************** 平台 start*********************************************/
    /** 平台网络公司列表 */
    platfromNetCompanyList = '/open-api/network/connection/query-list',

    /** 获取在平台Code */
    oauth2Code = '/open-platform/auth/oauth2/code',

    /*************************************************** 职位 **************************************************/
    query_user_job = '/zone/usergroup/info/query',
    override_user = '/zone/usergroup/override',
    /*************************************************** 角色 **************************************************/
    query_user_role = '/api/external/private/access/role/query',
    get_query_user_role = '/api/external/private/access/user-role/get',
    set_user_role = '/api/external/private/access/user-role/update',
    /* ************************************************** 职位end **************************************************/

    /* ************************************************* 平台 end*********************************************/

    /** 通过微信Code授权登录，网页 */
    AUTHORIZE_BY_CODE = '/auth/wx/oauth2/web/authorize-by-code',

    /** 微信绑定账号并继续授权登录，网页 */
    BIND_CONTINUE_AUTHORIZE = '/auth/wx/oauth2/web/bind-continue-authorize',

    /** 解除绑定 */
    UNBIND = '/global/account/3rd/unbind',

    /** 三方绑定列表 */
    ACCOUNT_3RD_LIST = '/global/account/3rd/list',

    /** 微信绑定账号（登录后） */
    OAUTH2_WEB_BIND_ONLY = '/auth/wx/oauth2/web/bind-only',
    /** 标签列表 */
    tagList = '/zone/network/label/mgmt/get',
    /** 标签新增 */
    tagAdd = '/zone/network/label/mgmt/create',
    /** 标签修改 */
    tagUpdate = '/zone/network/label/mgmt/update',
    /** 标签删除 */
    tagDel = '/zone/network/label/mgmt/delete',
    /** 给公司打标签 */
    companyApplyTag = '/zone/network/label/apply/tag',
    /** 标签下关联的公司的 */
    getCompaniesByLabels = '/zone/network/label/apply/getCompaniesByLabels',
    /** 获取所有标签分类以及标签 */
    getAllTagAndCateList = '/zone/network/label/getList',
    /** 新增标签分类 */
    addTagCategory = '/zone/network/label/category/create',
    /** 删除标签分类 */
    delTagCategory = '/zone/network/label/category/delete',
    /** 修改标签分类 */
    updateTagCategory = '/zone/network/label/category/update',
    /** 批量激活app */
    multiActivate = '/open-platform/app/instance/multi-activate',
    // 获取分类信息List
    queryCategory = '/open-platform/app/category/query',
    /** 根据appIdList 获取用户权限 */
    batchPermissionQuery = '/open-platform/app/instance/batch-permission-query',
    /** 根据appIdList 用户授权 */
    batchPermissionOverride = '/open-platform/app/instance/batch-permission-override',
    // 代理商模块 -- starat
    // 已授权
    agented = '/zone/company/agent/info/getAgent',
    // 授权申请
    agentApply = '/zone/company/agent/info/pageRecord',
    // 设置代理商查询
    agentQuery = '/zone/company/agent/info/agentedQueryAgent',
    // 设置代理商
    createAgent = '/zone/company/agent/info/create-relation-agented',
    // 代理商取消授权
    cancelAgent = '/zone/company/agent/info/agentedTerminate',
    // 同意拒绝授权申请
    handleRecordAgent = '/zone/company/agent/info/handleRecord',
    // 代理商模块 -- end
    
}
export default Urls;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/entry/constant/Urls/index.ts